export default "__VITE_ASSET__vT_qYhub__"